<birdz-map-popup [close]="data.close" [isLoading]="isLoading > 0">
  @if (pds) {
    <div class="bdz-map-popup-features">
      <div>
        <div class="bdz-map-popup-title">{{ equipmentLabel }}</div>
        <div class="equipment-with-link">
          <span>{{ pds.compteur }}</span>
          <span [innerHTML]="appLinkHTML | safeHtml"></span>
        </div>
      </div>
      <div>
        <div class="bdz-map-popup-title">{{ 'POPUP_DEVICE' | transloco }}</div>
        <div>{{ pds.module }}</div>
      </div>
      @if (showState) {
        <div>
          <div class="bdz-map-popup-title">{{ 'POPUP_STATE' | transloco }}</div>
          <div>{{ 'STATE_' + pds.state | transloco }}</div>
        </div>
      }
    </div>
  }
</birdz-map-popup>
